// extracted by mini-css-extract-plugin
export default {"hint":"Hint_hint__xcXJ1"};